export const NUMBER_CONDITIONS = [
  { condition: 'BEGINS_WITH', label: 'Começa com' },
  { condition: 'CONTAINS', label: 'Contém' },
]

export const TEXT_CONDITIONS = [
  { condition: 'BEGINS_WITH', label: 'Começa com' },
  { condition: 'CONTAINS', label: 'Contém' },
]

export const FILTERS_GROUPS = [
  {
    label: 'Pessoa unificada',
    group: 'unified_person',
  },
  {
    label: 'Sistema',
    group: 'system',
  },
]

export const FILTERS_SUBGROUPS = [
  {
    label: 'Informações',
    subgroup: 'unified_person_information',
  },
  {
    label: 'Documentos',
    subgroup: 'unified_person_documents',
  },
  {
    label: 'Informações',
    subgroup: 'system_information',
  },
]

export const FILTERS_FIELDS = [
  // UNIFIED PERSON
  // UNIFIED PERSON - INFORMATION
  {
    label: 'Nome da pessoa unificada',
    field: 'unified_person_name',
    subgroup: 'unified_person_information',
    group: 'unified_person',
    type: 'TEXT',
    conditions: TEXT_CONDITIONS,
    placeholderFirstValue: 'Digite o valor',
    defaultCondition: 'CONTAINS',
    defaultFirstValue: 'Melo',
  },
  {
    label: 'Nome social da pessoa unificada',
    field: 'unified_person_social_name',
    subgroup: 'unified_person_information',
    group: 'unified_person',
    type: 'TEXT',
    conditions: TEXT_CONDITIONS,
    placeholderFirstValue: 'Digite o valor',
    defaultCondition: 'CONTAINS',
    defaultFirstValue: '',
  },
  // UNIFIED PERSON - DOCUMENTS
  {
    label: 'Número do CPF da pessoa unificada',
    field: 'unified_person_cpf_number',
    subgroup: 'unified_person_documents',
    group: 'unified_person',
    type: 'NUMBER',
    conditions: NUMBER_CONDITIONS,
    placeholderFirstValue: 'Digite o valor',
    defaultCondition: 'CONTAINS',
    defaultFirstValue: '014',
  },
  // SYSTEMS
  // SYSTEMS - INFORMATION
  {
    label: 'Nome do sistema',
    field: 'system_name',
    subgroup: 'system_information',
    group: 'system',
  },
]
